import * as types from "../types";
import { getCookiesAcceptance, setCookieAccepted } from "../../config/storageData";

const accountState = {
  isLoader: false,
  isSnackbar: false,
  snackbarMessage: "",
  cookiesAccepted: getCookiesAcceptance()
};

export default function(state = accountState, action) {
  switch (action.type) {
    case types.REQUEST_LOADER: {
      return {
        ...state,
        isLoader: action.value
      };
    }
    case types.OPEN_SNACKBAR: {
      return {
        ...state,
        isSnackbar: true,
        snackbarMessage: action.message,
        severity: action.severity
      };
    }
    case types.CLOSE_SNACKBAR: {
      return {
        ...state,
        isSnackbar: false
      };
    }
    case types.SET_COOKIES_ACCEPTED: {
      setCookieAccepted();
      return {
          ...state,
          cookiesAccepted: action.value
      };
  }
  }

  return state;
}
